import { render, staticRenderFns } from "./TiefbauIcon.vue?vue&type=template&id=38356085&scoped=true"
import script from "./TiefbauIcon.vue?vue&type=script&lang=js"
export * from "./TiefbauIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38356085",
  null
  
)

export default component.exports